/* THIS FILE WAS CREATED USING THE bb upload-icons COMMAND */
/* eslint-disable */

const uncommonIconManifest = {
  "fas/angle-double-down": "01Kltl4428L",
  "fas/angle-double-up": "017ZWbZyHOL",
  "fas/bars": "01QsH5-50qL",
  "fas/bell": "01LdW-Ih7uL",
  "fas/caret-down": "01fNLUNVbyL",
  "fas/caret-left": "01JMYTRZQXL",
  "fas/caret-right": "01-aRyWt4FL",
  "fas/caret-up": "01X7MPwcGuL",
  "fas/check-circle": "015Hu3WsZsL",
  "fas/cog": "015heWkP6jL",
  "fas/desktop": "01AvFpG8s+L",
  "fas/download": "01RpkIojzmL",
  "fas/exchange": "01rAZ6r370L",
  "fas/lock": "01o-Q-mx-aL",
  "fas/long-arrow-down": "01jH-2SxtZL",
  "fas/long-arrow-up": "01SwUsazozL",
  "fas/minus-square": "01kLc2PO8EL",
  "fas/mobile": "01ueTxisxDL",
  "fas/pencil": "01Yyy8PpSaL",
  "fas/plus-square": "01U6pJ4UHCL",
  "fas/question-circle": "01cze47AJuL",
  "fas/signal": "01TCk4PDHIL",
  "fas/sitemap": "01E01munfEL",
  "fas/sort": "01gMpY48NUL",
  "fas/tablet": "01uPwu3b3NL",
  "fas/upload": "01upSwwtTuL",
  "fas/user-circle": "01iAn5bMZGL",
  "fas/user": "01FDqHMPKyL",
  "far/calendar": "01R+6edAsYL",
  "far/lightbulb": "01c2TdPzKIL",
  "far/text-separator": "01SANgrnfeL",
  "far/window-minimize": "01QVK7DCxTL"
};

export { uncommonIconManifest as u };
//# sourceMappingURL=uncommonIconManifest-C_l-Bygp.js.map
